import Loader from "components/loader";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as yup from "yup";
import { addForm, getFormById, updateForms } from "../../axios/api";
import { renderError } from "../../utils/utils";
import { toast } from "react-toastify";

const AddForms = () => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location?.state;

  const [formData, setFormData] = useState<any>();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      title: "",
      form_url: "",
    },
    onSubmit: async (values) => {
      // console.log("values", values);
      const reqBody = {
        ...values,
        title: encodeURI(values?.title),
        locale: "1",
        form_id: formik.values.title,
      };
      try {
        setLoading(true);
        let responseData;
        if (id) {
          responseData = await updateForms(reqBody, id);
          if (responseData?.data?.success) {
            toast.success("Forms Updated Sucessfully");
            navigate("/admin/forms");
          } else {
            toast.error(responseData?.data?.message);
          }
        } else {
          responseData = await addForm(reqBody);
          if (responseData?.data?.success) {
            toast.success("Forms Added Sucessfully");
            navigate("/admin/forms");
          } else {
            toast.error(responseData?.data?.message);
          }
        }
      } catch (error) {
        console.error("API Error:", error);
        toast.error("Something Went Wrong" + error);
      } finally {
        setLoading(false);
      }
    },
    validationSchema: yup.object({
      title: yup.string().trim().required("Form Title is required"),
      form_url: yup
        .string()
        .required("Form URL is required")
        .matches(/^https:\/\/.+$/, "Wrong Form URL"),
    }),
  });

  useEffect(() => {
    const fetchForm = async (id: string) => {
      try {
        setLoading(true);
        const formDataResp = await getFormById(id);
        setFormData(formDataResp?.data?.data);
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      fetchForm(id);
    }
  }, [id]);

  useEffect(() => {
    if (formData) {
      formik.setValues({
        title: formData.title,
        form_url: formData.form_url,
      });
    }
  }, [formData]);

  return (
    <div className="m-3 bg-[#FFFFFF] p-3">
      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="my-5 flex w-11/12 flex-col">
            <div className="flex w-[100%] items-center justify-between gap-4">
              <div className="my-2 flex min-w-[50%] flex-col items-start justify-center gap-2">
                <label htmlFor="title" className="text-xl font-medium">
                  Form Title
                </label>
                <input
                  type="text"
                  name="title"
                  id="title"
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter Form title here"
                  className="h-10 w-[100%] rounded-md border-[2px] border-[#E4E6EF] bg-[transparent] p-2"
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="text-lg text-red-500">
                    {renderError(formik.errors.title)}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="flex w-[100%] items-center justify-between gap-4">
              <div className="my-2 flex min-w-[50%] flex-col items-start justify-center gap-2">
                <label htmlFor="form_url" className="text-xl font-medium">
                  Form URL
                </label>
                <div className="relative w-[100%]">
                  <input
                    type="text"
                    name="form_url"
                    id="form_url"
                    value={formik.values.form_url}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Enter Form URL here"
                    className="h-10 w-[100%] rounded-md border-[2px] border-[#E4E6EF] bg-[transparent] p-2"
                  />
                </div>
                {formik.touched.form_url && formik.errors.form_url ? (
                  <div className="text-lg text-red-500">
                    {renderError(formik.errors.form_url)}
                  </div>
                ) : null}
              </div>
            </div>

            <div>
              <button
                name="submit"
                className="float-right my-5 w-24 rounded bg-[#008BD2] p-2 text-xl font-bold text-white"
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddForms;
